import { render, staticRenderFns } from "./addNewKiosk.vue?vue&type=template&id=778bc6c0"
import script from "./addNewKiosk.vue?vue&type=script&lang=js"
export * from "./addNewKiosk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports